export default "__VITE_ASSET__j34Umqn1__"